import {
  WIFI,
  ICON_X,
  RSS_FEED,
  SORT_ASC,
  AUTO_FLOW,
  SORT_DESC,
  RIGHT_CARET,
  LINKEDIN_48,
  CLIENT_LOGO,
  LINKEDIN_144,
  CIRCLE_ALERT,
  CHEVRON_DOWN,
  SECURITY_ICON,
  UNDRAW_WARNING,
  EXPLORE_SOCIUU,
  USER_CIRCLE_ICON,
  TAGS_ICON_STYLE_1,
  TAGS_ICON_STYLE_2,
  TEMPLATE_WELCOME_EMAIL,
} from "./icons.const";

export interface IIcons {
  name: string;
  svg: string;
}

export const ICONS: IIcons[] = [
  {
    name: 'security',
    svg: SECURITY_ICON,
  },
  {
    name: 'right-caret',
    svg: RIGHT_CARET,
  },
  {
    name: 'user-circle',
    svg: USER_CIRCLE_ICON,
  },
  {
    name: 'tags',
    svg: TAGS_ICON_STYLE_1,
  },
  {
    name: 'tags-2',
    svg: TAGS_ICON_STYLE_2,
  },
  {
    name: 'welcome-email-template',
    svg: TEMPLATE_WELCOME_EMAIL,
  },
  {
    name: 'undraw-warning',
    svg: UNDRAW_WARNING,
  },
  {
    name: 'x-mini',
    svg: ICON_X,
  },
  {
    name: 'linkedin-48',
    svg: LINKEDIN_48,
  },
  {
    name: 'linkedin-144',
    svg: LINKEDIN_144,
  },
  {
    name: 'wifi',
    svg: WIFI,
  },
  {
    name: 'rss_feed',
    svg: RSS_FEED,
  },
  {
    name: 'sort_asc',
    svg: SORT_ASC,
  },
  {
    name: 'sort_desc',
    svg: SORT_DESC,
  },
  {
    name: 'autoflow',
    svg: AUTO_FLOW,
  },
  {
    name: 'explore-sociuu',
    svg: EXPLORE_SOCIUU,
  },
  {
    name: 'client-logo',
    svg: CLIENT_LOGO,
  },
  {
    name: 'circle-alert',
    svg: CIRCLE_ALERT,
  },
  {
    name: 'chevron-down',
    svg: CHEVRON_DOWN,
  },
];
